import classnames from 'classnames';

import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button';
import Label from 'components/form/Label/Label';
import { getFundCashUI } from 'pages/Cash/helpers/cashHelpers';
import './IncompleteAccountOptions.scss';

const CashFundAccountCTA = ({
  showPinCTA,
  handleHowToTransferModal,
  handleTransferBalanceModal,
  handleSetPinClick,
  frozenCard,
  datatestid,
}) => {
  return (
    <FlexContainer className="CashFundAccountCTA flex-tablet-col align-self-end tablet-justify-center m-format100">
      {showPinCTA ? (
        <Button
          datatestid={`${datatestid}-setPin`}
          onClick={handleSetPinClick}
          mrphType="primary"
          disabled={frozenCard}
        >
          Set Card PIN
        </Button>
      ) : (
        <FlexContainer className="flex-tablet-col transfer-cta-container">
          <Button
            datatestid={`${datatestid}-howToTransferMoney`}
            onClick={handleHowToTransferModal}
            mrphType="standard"
          >
            How to Add Money
          </Button>
          <div className="padR12 mobileHide" />
          <div className="padB12 desktopHide" />
          <Button
            datatestid={`${datatestid}-transferMoney`}
            onClick={() =>
              handleTransferBalanceModal({
                type: 'moveMoney',
              })
            }
            mrphType="primary"
          >
            Add Money
          </Button>
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

export const IncompleteAccountOptions = ({
  sesameCashAccount,
  datatestid,
  handleHowToTransferModal,
  handleTransferBalanceModal,
  handleSetPinClick,
  frozenCard,
  ...props
}) => {
  const { fundAccountTitle, fundAccountMessage, showPinCTA, imageClass } =
    getFundCashUI(sesameCashAccount);

  const classes = classnames(
    'IncompleteAccountOptions justify-between flex-mobile-col',
    { frozenCard: frozenCard },
    { showPinCTA: showPinCTA },
  );
  return (
    <>
      <FlexContainer className={classes}>
        <FlexContainer className="image-container margR16 m-format100 justify-center">
          <div data-testid={`${datatestid}-image`} className={imageClass}></div>
        </FlexContainer>
        <div className="padB24 desktopHide" />

        <FlexContainer className="action-container flex-column m-format100 justify-around mobile-justify-center">
          <div>
            <div className="padB8" />
            <Label
              datatestid={`${datatestid}-title`}
              typeHeader={'h5'}
              className="H5 mH5"
            >
              {fundAccountTitle}
            </Label>
            <div className="padB8" />
            <Label type="Body-2" datatestid={`${datatestid}-message`}>
              {fundAccountMessage}
            </Label>
          </div>
          <div className="padB16" />
          <CashFundAccountCTA
            showPinCTA={showPinCTA}
            handleHowToTransferModal={handleHowToTransferModal}
            handleTransferBalanceModal={handleTransferBalanceModal}
            handleSetPinClick={handleSetPinClick}
            datatestid={datatestid}
            frozenCard={frozenCard}
          />
        </FlexContainer>
      </FlexContainer>
    </>
  );
};
